import {UyapRequest} from "./UyapRequest";
import app from "@/main";

export interface KurumAutoSearchTalep {
    kurumAdi: string     // base64 halinde gidecek
}

export interface KurumAutoSearchCevap {
    error: string,
    kisiKurumID: number,
    kurumAdi: string,
    vergiNo: string,
    ticaretSicilNo?: string,
    ticaretSicilNoVerildigiYer?: string,
    harcDurumu?: number,
    kamuOzel?: string,
    sskIsyeriSicilNo?: string,
    mersisNo?: string,
    veriGelisYeri: number,
    merkezAdresi?: IAdres,
    faaliyetDurumu: number,
    ortakBilgileri?: Array<OrtakBilgisi>,
    temsilciBilgileri?: Array<TemsilciBilgisi>,
    tacirMi: string,
    mersisIlKodu: number,
    mersisIlceKodu: number,
    guncellenmeTarihi?: string,
    sermayesi?: number,
    tescilTarihi?: string,
    terkinTarihi?: string
}

interface IAdres {
    ilKodu?: number
    ilAdi?: string
    ilceAdi?: string
    ilceKodu?: number
    adres: string
    kisiKurumID: number
    adresID: number
    adresTuru: string
    adresTuruAciklama: string
    eklemeTarihi: string
    eklenebilirAdresMi: boolean
    kayitliAdresMi: boolean
    aktifAdresmi: boolean
    guncellendiMi: boolean
    aktif: string
    ekleyeninAdi?: string
    ekleyeninSoyadi?: string
    ekleyeninBirimi?: string
    ekleyeninBirimId?: string
    ekleyeninSicili?: string
}

interface OrtakBilgisi {
    ortakTipi: number,
    adi: string,
    soyadi: string,
    unvan: string,
    tcKimlikNo?: string
    sermayesi?: number
}

interface TemsilciBilgisi {
    tcKimlikNo: string
    adi: string
    soyadi: string
    temsilciTipi: number
    unvani: string
    KisiTipiKodu: number
    temsilTuru: string
    yetkiSuresiGun: number
    yetkiSuresiAy: number
    yetkiSuresiYil: number
}

export default class KurumAutoSearch extends UyapRequest<KurumAutoSearchTalep, KurumAutoSearchCevap[]> {
    delayTime = 1000;

    getMethod(): 'GET' | 'POST' {
        return 'GET';
    }

    getSpinnerMessage(){
        return "Kurum otomatik arama yapılıyor...";
    }


    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "kurumAutoSearch_" + app.$uyapHelper.hash(this.talepData)
        };
    }

    getUrl(): string {
        // https://avukatbeta.uyap.gov.tr/kurumAutoSearch.ajx?kurumAdi=ZGVuZW1l
        return this.ImzaClientAddr + "kurumAutoSearch.ajx";
    }

    getMockResponse(): any {
        return [{"kisiKurumID":180110860,"kurumAdi":"DENEME EĞİTİM HİZMETLERİ LİMİTED ŞİRKETİ","vergiNo":"2910738319","ticaretSicilNo":"544","ticaretSicilNoVerildigiYer":"İSTANBUL TİCARET SİCİL MÜDÜRLÜĞÜ","harcDurumu":1,"kamuOzel":"O","sskIsyeriSicilNo":"582912-0","mersisNo":"0291073831900014","veriGelisYeri":0,"merkezAdresi":{"ilKodu":34,"ilAdi":"İSTANBUL","ilceAdi":"BAYRAMPAŞA","ilceKodu":7,"adres":"YILDIRIM MAH.ESKİ EDİRNE ASFALTI NO.187 BAYRAMPAŞA/İSTANBUL","kisiKurumID":180110860,"adresID":179107294,"adresTuru":"ADRTR00011","adresTuruAciklama":"Mersis Adresi","eklemeTarihi":"Jul 20, 2016 3:16:55 PM","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":false,"guncellendiMi":false,"aktif":"E"},"faaliyetDurumu":3,"ortakBilgileri":[],"temsilciBilgileri":[],"sermayesi":0,"tescilTarihi":"23/3/2006","tacirMi":"H","mersisIlKodu":0,"mersisIlceKodu":0,"terkinTarihi":"18/2/2015"},{"kisiKurumID":253495808,"kurumAdi":"DENEME FEDERASYONU","vergiNo":"2900797739","harcDurumu":1,"kamuOzel":"O","veriGelisYeri":0,"merkezAdresi":{"adres":"AŞAĞI EĞLENCE MAH. ALTINOLUK CAD. Kapı No: 10 A Daire No:  KEÇİÖREN/ANKARA","kisiKurumID":253495808,"adresID":380047298,"adresTuru":"ADRTR00021","adresTuruAciklama":"Gib Adresi","eklemeTarihi":"Jun 10, 2025 11:44:52 AM","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":false,"guncellendiMi":false,"aktif":"E"},"faaliyetDurumu":-1,"tacirMi":"H","mersisIlKodu":0,"mersisIlceKodu":0},{"kisiKurumID":217601349,"kurumAdi":"DENEME LİSESİ KURS YÖNETİM KURULU KORUMADERNEĞİ","vergiNo":"2910008591","veriGelisYeri":0,"faaliyetDurumu":-1,"tacirMi":"H","mersisIlKodu":0,"mersisIlceKodu":0}];
    }

    async parse(data: any): Promise<Array<KurumAutoSearchCevap>> {
        if (!Array.isArray(data)) {
            return data;
        }

        return data.map((item: KurumAutoSearchCevap) => ({
            ...item,
            // UYAP sometimes returns kurum names with trailing/leading spaces; trim to keep data clean.
            kurumAdi: typeof item.kurumAdi === 'string' ? item.kurumAdi.trim() : item.kurumAdi,
        }));
    }

}
